import React from 'react';
import { useGlobal } from 'reactn';
import BillableHoursCell from './BillableHoursCell';

const BillableHoursCellWrapper = ({ timesheetId, totalHours }) => {
  const [config] = useGlobal('config');
  const showBillableHoursConfig = config['show-report-billable-hours'];
  const showBillableHours = showBillableHoursConfig === 'true' || showBillableHoursConfig === "1";

  if (!showBillableHours) {
    return <div>{totalHours}</div>;
  }

  return <BillableHoursCell timesheetId={timesheetId} totalHours={totalHours} />;
};

export default BillableHoursCellWrapper;